module.exports = __webpack_public_path__ + "fonts/fontello.4c1a1eb.woff2";